import { render } from "./labelling-queue.vue?vue&type=template&id=17fff522"
import script from "./labelling-queue.vue?vue&type=script&lang=js"
export * from "./labelling-queue.vue?vue&type=script&lang=js"

import "./labelling-queue.vue?vue&type=style&index=0&id=17fff522&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__